<template>
  <header class="header grid-x grid-padding-x flex items-center justify-between py-4 px-8">
    <button
      type="button"
      class="mobile-navigation-toggle"
      aria-label="Открыть меню"
      @click="$eventBus.$emit('mobile.navigation.toggle')">
      <span></span>
      <span></span>
      <span></span>
    </button>
    <slot></slot>
    <div class="header-actions flex flex-shrink justify-end">
      <router-link
        tag="button"
        class="header-requests-button btn btn-sm btn-primary font-normal"
        :to="{ name: 'contractors.requests' }">
        Запросы
      </router-link>
      <div
        class="header-notification ml-12 pl-1"
        v-b-modal="'notifications'">
        <div>
          <img src="@/assets/icons/bell-bg.svg" alt="">
          <span>{{ unread }}</span>
        </div>
        <span>Уведомления</span>
      </div>
    </div>
  </header>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      unread: (state) => state.notifications.unread,
    }),
  },
};
</script>
